import React from "react";
import ImageUpload from "./ImageUpload";
const ImageUploadField = (props) => {
  const {
    placeholder,
    label,
    meta: { touched, error },
    fileurl,
    input,
  } = props;
  return (
    <ImageUpload
      label={label}
      onChange={input.onChange}
      value={input.value}
      placeholder={placeholder}
      touched={touched}
      error={error}
      input={{ ...input }}
    />
  );
};

export default ImageUploadField;
